import { useState, useEffect, useRef } from 'react';
import './App.css';
import Navbar from './components/Navbar.js';
import Masonry from 'responsive-masonry-layout';
import Card from './components/Card.js';
import SegmentedControl from './components/SegmentedControl.js';
import TagFilterDropdown from './components/TagFilterDropdown.js';
import { ReactTyped } from 'react-typed';
import { projectData, employmentData, profileData, navbarData } from './config';

function App() {
  const [view, setView] = useState('employment');
  const [selectedTag, setSelectedTag] = useState('');
  const [isNavbarDropdownOpen, setIsNavbarDropdownOpen] = useState(false);

  useEffect(() => {
    setSelectedTag('');
  }, [view]);

  const allTags = Array.from(
    new Set(
      (view === 'projects' ? projectData : employmentData).flatMap((card) =>
        card.tags.map((tag) => tag.label),
      ),
    ),
  );

  const handleTagSelect = (tag) => {
    setSelectedTag(tag);
  };

  const filteredCards = selectedTag
    ? (view === 'projects' ? projectData : employmentData).filter((card) =>
        card.tags.some((tag) => tag.label === selectedTag),
      )
    : (view === 'projects' ? projectData : employmentData);

  const cards = filteredCards.map((item) => (
    <Card
      key={item.id}
      image={item.image}
      title={item.title}
      subtitle={
        view === 'projects' ? item.date : item.company + ' • ' + item.date
      }
      description={item.description}
      link={item.link}
      tags={item.tags}
    />
  ));

  return (
    <>
      <Navbar
        items={navbarData}
        isNavbarDropdownOpen={isNavbarDropdownOpen}
        setIsNavbarDropdownOpen={setIsNavbarDropdownOpen}
      />

      <div
        style={{
          visibility: isNavbarDropdownOpen ? 'hidden' : 'visible',
          maxHeight: isNavbarDropdownOpen ? '0' : 'auto',
          overflow: isNavbarDropdownOpen ? 'hidden' : 'visible',
        }}
      >
        <div className="content-container">
          {/* Intro Section */}
          <div className="intro-section">
            <img src={profileData.photo} className="intro-section__photo" alt="" />
            <h1 className="section-heading">
              <ReactTyped strings={profileData.greeting} backDelay={1000} typeSpeed={30} />
            </h1>
            <p className="intro-section__about">{profileData.about}</p>
            <a
              href="/resume.pdf"
              className="intro-section__resume-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              Resume
            </a>
          </div>

          <hr />

          {/* Technical Experience Section */}
          <h1 className="section-heading">Technical Experience</h1>
          <SegmentedControl
            defaultIndex={0}
            callback={(value) => setView(value)}
            segments={[
              {
                label: 'Employment',
                value: 'employment',
                ref: useRef(),
              },
              {
                label: 'Projects',
                value: 'projects',
                ref: useRef(),
              },
            ]}
          />
          {/* <TagFilterDropdown key={view} tags={allTags} onTagSelect={handleTagSelect} /> */}
          <Masonry items={cards} columnWidth={22 + 2 * 0.0625} maxColumns={3} spacing={2} />
        </div>
      </div>
    </>
  );
}

export default App;
